class FooterCalendar {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    // let date = new Date();

    // $('.js-change-date').html(`${date.getFullYear()}年 ${date.getMonth() + 1}月`)

    // let swiper = new Swiper(".mySwiper", {
    //   initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
    //   navigation: {
    //     nextEl: ".next-btn",
    //     prevEl: ".prev-btn",
    //   },
    //   spaceBetween: 50,
    //   speed: 500,
    // });
  }
}
